/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { WorkProgressDto } from './WorkProgressDto';
import {
    instanceOfWorkProgressDto,
    WorkProgressDtoFromJSON,
    WorkProgressDtoFromJSONTyped,
    WorkProgressDtoToJSON,
} from './WorkProgressDto';

/**
 * @type JobOccurrenceCatalogDtoWorkProgressSummary
 * 
 * @export
 */
export type JobOccurrenceCatalogDtoWorkProgressSummary = WorkProgressDto;


export function JobOccurrenceCatalogDtoWorkProgressSummaryFromJSON(json: any): JobOccurrenceCatalogDtoWorkProgressSummary {
    return JobOccurrenceCatalogDtoWorkProgressSummaryFromJSONTyped(json, false);
}

export function JobOccurrenceCatalogDtoWorkProgressSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobOccurrenceCatalogDtoWorkProgressSummary {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...WorkProgressDtoFromJSONTyped(json, true) };
    return  WorkProgressDtoFromJSONTyped(json, true);
}

export function JobOccurrenceCatalogDtoWorkProgressSummaryToJSON(value?: JobOccurrenceCatalogDtoWorkProgressSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfWorkProgressDto(value)) {
        return WorkProgressDtoToJSON(value as WorkProgressDto);
    }

    return {};
}

/**
 * Check if a given object implements the JobOccurrenceCatalogDtoWorkProgressSummary interface.
 */
export function instanceOfJobOccurrenceCatalogDtoWorkProgressSummary(value: any): value is JobOccurrenceCatalogDtoWorkProgressSummary {
    if (instanceOfWorkProgressDto(value)) return true;
    return false;
}

